import { makeActionCreator } from 'crazyEditor/redux/helpers';

const SET_OPEN = 'crazyEditor/publishDialog/SET_OPEN';
const SET_ITEMS = 'crazyEditor/publishDialog/SET_ITEMS';
const SET_SNACKBAR = 'crazyEditor/publishDialog/SET_SNACKBAR';
const SET_REVISE_ERROR = 'crazyEditor/publishDialog/SET_REVISE_ERROR';

const initialState = {
  open: false,
  items: null,
  firstTime: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_OPEN:
      return {
        ...state,
        firstTime: action.firstTime,
        open: action.open
      };
    case SET_ITEMS:
      return {
        ...state,
        items: action.items
      };
    case SET_SNACKBAR:
      return {
        ...state,
        snackbarProps: action.snackbarProps,
      };
    case SET_REVISE_ERROR:
      return {
        ...state,
        reviseError: action.reviseError,
      };
    default:
      return state;
  }
}

export function setOpen(open = true, firstTime = false) {
  return { type: SET_OPEN, open, firstTime };
}

export function openPublishDialog(firstTime = false) {
  return setOpen(true, firstTime);
}

export function setItems(items) {
  return { type: SET_ITEMS, items };
}
export const setSnackbar = makeActionCreator(SET_SNACKBAR, 'snackbarProps');

export const setReviseError = makeActionCreator(SET_REVISE_ERROR, 'reviseError');
